import cls from "classnames";
import { MultiCurrency } from "@qoohoo/common/utils/currency";
import OrderSummaryModal from "./modals/OrderSummaryModal";
import useStore from "../../store/store";

export default function withJoinButtonWithTaxDetails(Component) {
  return (props) => {
    const {
      channelDetails,
      couponState = {},
      currentSelectedPlan
    } = props;

    const OrderSummaryModalController = useStore((state) => state.OrderSummaryModalController);

    const hasMultiplePlans = channelDetails?.plans?.length > 1;
    const isOneTimePlan = channelDetails.type?.toLowerCase() === "one_time";
    const selectedChannelPlan = hasMultiplePlans ? currentSelectedPlan : channelDetails?.plans?.[0];

    let channelFee;

    if (isOneTimePlan) {
      channelFee = channelDetails?.channel_fee;
    } else {

      channelFee =
        selectedChannelPlan?.amount_after_discount || selectedChannelPlan?.amount;
    }

    const couponDiscount = isOneTimePlan
      ? couponState.data
      : couponState.data?.[selectedChannelPlan?.uid];
    const currency = channelDetails?.currency;

    const showStrikeThroughAmount = !hasMultiplePlans && couponDiscount;

    function getChannelFeeLabel() {
      let label = "";

      let finalAmount = channelFee;

      if (couponDiscount) {
        finalAmount = couponDiscount.amount_after_coupon_discount;
      }
      if (finalAmount) {
        label = `${MultiCurrency.formatAmountWithSymbol(finalAmount, currency)}`;
      } else {
        label = "";
      }

      return label;
    }

    const onClickViewDetails = () => {
      OrderSummaryModalController().openModal({
        channelDetails,
        plan_uid: selectedChannelPlan?.uid,
        coupon_code: couponState?.coupon
      });
    };

    function renderChannelFee() {
      return (
        <div className="flex flex-row items-center font-bold text-base leading-[18px] mr-8">
          {showStrikeThroughAmount && (
            <div className="line-through opacity-50 font-normal mr-1 text-xs pt-[2px]">
              {`${MultiCurrency.formatAmountWithSymbol(channelFee, currency)}`}
            </div>
          )}
          {getChannelFeeLabel()}
          {
            <div className="font-normal ml-1 text-xs text-[#E7E7E7] pt-[2px] w-10">
              + taxes
            </div>
          }
        </div>
      );
    }

    function renderViewDetails() {
      return (
        <button
          className="font-normal mt-1 text-xs hover:opacity-80 text-[#26a6e7]"
          onClick={onClickViewDetails}
        >
          View details
        </button>
      );
    }

    return (
      <div className="flex flex-row items-center justify-between w-full">
        <div className="flex flex-col items-start justify-end">
          {renderChannelFee()}
          {renderViewDetails()}
        </div>
        <Component {...props} />
      </div>
    );
  }
}